<template>
  <div class="report__vertical-separator" :style="styles"></div>
</template>

<script>
export default {
  props: {
    gap: String,
    height: [Number, String],
  },
  computed: {
    styles() {
      return {
        marginRight: this.gap || 0,
        marginLeft: this.gap || 0,
        height: this.height || undefined,
      };
    },
  },
};
</script>

<style>
.report__vertical-separator {
  border-left: 1.5px solid #eaeaea;
}
</style>
